import React from "react";

const ScheduleDownloadHolidayTable = ({ holidays, paramDate, currentWorkdays, morning, afternoon, getSingleUserData }) => {
    const [month, year] = paramDate.split('-');
    const monthName = new Date(year, month - 1).toLocaleString('en-US', { month: 'long' });
    let totalWorkedDay = currentWorkdays;
    if (morning && afternoon) {
        totalWorkedDay -= (parseInt(morning) + parseInt(afternoon)) * 0.5;
    } else if (morning) {
        totalWorkedDay -= parseInt(morning) * 0.5;
    } else if (afternoon) {
        totalWorkedDay -= parseInt(afternoon) * 0.5;
    }

    return (
        <>
            <div>
                <div><span>This term Statistics</span></div>
                <table className="holiday_table">
                    <thead>
                        <tr>
                            <th>Morning holiday</th>
                            <th>Afternoon Holiday</th>
                            <th>Special Duty</th>
                            <th>Paid holiday</th>
                            <th>Special leave</th>
                            <th>Absence</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{holidays?.current_term?.morning}</td>
                            <td>{holidays?.current_term?.afternoon}</td>
                            <td>{holidays?.current_term?.other}</td>
                            <td>{holidays?.current_term?.paid}</td>
                            <td>{holidays?.current_term?.special}</td>
                            <td>{holidays?.current_term?.absence}</td>
                        </tr>
                    </tbody>
                </table>
    
                <div><span>{paramDate} Statistics</span></div>
                <table className="holiday_table">
                    <thead>
                        <tr>
                            <th>Morning holiday</th>
                            <th>Afternoon Holiday</th>
                            <th>Special duty</th>
                            <th>Paid leave</th>
                            <th>Special leave</th>
                            <th>Absence</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{holidays?.every_month?.morning}</td>
                            <td>{holidays?.every_month?.afternoon}</td>
                            <td>{holidays?.every_month?.other}</td>
                            <td>{holidays?.every_month?.paid}</td>
                            <td>{holidays?.every_month?.special}</td>
                            <td>{holidays?.every_month?.absence}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    
            <div><span>Working Status</span></div>
            <table className="holiday_table">
                <thead>
                    <tr>
                        <th>Basic working days in the current term</th>
                        <th>Number of days worked in the current term</th>
                        <th>Basic working days in {monthName} Month</th>
                        <th>Number of days worked in {monthName} Month</th>
                        <th>Basic working hours in {monthName} Month</th>
                        <th>Working hours in {monthName} Month</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{getSingleUserData.workdays_in_year ? getSingleUserData.workdays_in_year : 0} days</td>
                        <td>{getSingleUserData.current_workdays_in_year ? getSingleUserData.current_workdays_in_year : 0} days</td>
                        <td>{getSingleUserData.working_days ? getSingleUserData.working_days : 0} days</td>
                        <td>
                            {getSingleUserData.morning && getSingleUserData.afternoon ? (
                                getSingleUserData.current_workdays - (getSingleUserData.morning + getSingleUserData.afternoon) * 0.5
                            ) : getSingleUserData.morning ? (
                                getSingleUserData.current_workdays - getSingleUserData.morning * 0.5
                            ) : getSingleUserData.afternoon ? (
                                getSingleUserData.current_workdays - getSingleUserData.afternoon * 0.5
                            ) : (
                                getSingleUserData.current_workdays
                            )} days
                        </td>
                        <td>{getSingleUserData.working_days ? getSingleUserData.working_days * 8 : 0} hours</td>
                        <td>{getSingleUserData.t_diff ? getSingleUserData.t_diff : 0} hours</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default ScheduleDownloadHolidayTable;